<template>
  <div class="item" :class="{ failed: error }">
    <label v-if="label" :for="id" class="form-control-label">
      {{ label }}
      <span v-if="required">*</span>
    </label>
    <input
      :id="id"
      :type="type"
      :placeholder="`${placeholder}${!label && required ? '*' : ''}`"
      v-bind="$attrs"
      class="form-control"
      :class="{ failed: error }"
      :value="modelValue"
      @input="$emit('update:modelValue', $event.target.value)"
    />
  </div>
</template>
<script>
import { computed } from 'vue';

export default {
  name: 'TextField',
  props: {
    id: {
      type: [String, Number],
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    rules: {
      type: Array,
      default: () => {
        return [];
      }
    },
    error: {
      type: Boolean,
      default: false
    },
    modelValue: String
  },
  emits: ['update:modelValue'],
  setup(props) {
    const required = computed(() => {
      return props.rules.includes('required');
    });

    return {
      required
    };
  }
};
</script>
